export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7264.5130cbba.jpg";